import React, { useEffect, useState } from 'react'
import GetDiagnosisData from '../../../src/services/general/getDiagnosisData.api'
import { CButton, CCol, CModal, CModalBody, CModalFooter, CModalHeader, CModalTitle, CRow } from '@coreui/react'
import ListView from '../../../src/components/shared/ListView'
import SaveExtra from '../../../src/services/general/saveExtraData.api'
import { CAccordion, CAccordionBody, CAccordionHeader, CAccordionItem } from '@coreui/react'
import AccordianEditDelete from '../../../src/components/shared/AccordianEditDelete'
import DifferentialSuggestion from './DifferentialSuggestion'
import SaveQuestionProvider from '../../../src/services/general/saveQuestionsProvider.api'

const Diagnosisdata = () => {
  const [diagnosisData, setDiagnosisData] = useState([])
  const [isPageLoading, setIsPageLoading] = useState(false)
  const [selectedDiagnostic, setSelectedDiagnostic] = useState('')
  const [dataForSelectedDiagnostic, setDataForSelectedDiagnostic] = useState({
    'Diffrential Diagnosis': [],
    'General Plan Statements': [],
    'Assessment Suggestion': [],
    HPI: [],
    Subjective: [],
    Incident: [],
  })

  const getData = async () => {
    setIsPageLoading(true)
    try {
      let a = await GetDiagnosisData()
      let data = JSON.parse(a.d)
      setDiagnosisData(data?.Data)
    } catch (error) {
      console.log(error)
    } finally {
      setIsPageLoading(false)
    }
  }

  const [showModal, setShowModal] = useState(false) // to open the detail modal

  useEffect(() => {
    getData()
  }, [])

  const handleView = (item) => {
    setShowModal(true)
    setSelectedDiagnostic({
      name: item.Name,
      id: item.id,
      code: item.Code,
    })
  }

  const GetDiffrentialDiagnosis = async () => {
    setIsPageLoading(true)
    try {
      let response = await GetDiagnosisData('')
      let diagnosis = JSON.parse(response.d)?.Data
      let data = await SaveExtra('Get_By_Type', 'generalPlanStatements', '', '')
      data = JSON.parse(data.d)?.Data || []
      if (data) {
        data = data?.map((item) => {
          return {
            Id: item.Id,
            Data: JSON.parse(item?.JsonData),
          }
        })
      }
      if (data.length > 0) {
        let foundAccordionsForSelectedDiagnostic = await data.find((item) => item?.Data?.diagnosis?.label === selectedDiagnostic.name)
        if (foundAccordionsForSelectedDiagnostic) {
          setDataForSelectedDiagnostic((p) => ({
            ...p,
            'Diffrential Diagnosis': foundAccordionsForSelectedDiagnostic.Data?.accordions || [],
          }))
        }
      }
    } catch (error) {
      console.log(error)
    } finally {
      setIsPageLoading(false)
    }
  }

  const GetAssessmentSuggestion = async () => {
    setIsPageLoading(true)
    try {
      let response = await GetDiagnosisData('')
      let diagnosis = JSON.parse(response.d)?.Data
      let data = await SaveExtra('Get_By_Type', 'AssesmentSuggestions', '', '')
      data = JSON.parse(data.d)?.Data || []
      if (data) {
        data = data?.map((item) => {
          return {
            Id: item.Id,
            Data: JSON.parse(item?.JsonData),
          }
        })
      }
      if (data.length > 0) {
        let foundAccordionsForSelectedDiagnostic = await data.find((item) => item?.Data?.diagnosis?.label === selectedDiagnostic.name)
        if (foundAccordionsForSelectedDiagnostic) {
          setDataForSelectedDiagnostic((p) => ({
            ...p,
            'Assessment Suggestion': foundAccordionsForSelectedDiagnostic.Data?.accordions || [],
          }))
        }
      }
    } catch (error) {
      console.log(error)
    } finally {
      setIsPageLoading(false)
    }
  }

  const GetGeneralPlanStatements = async () => {
    setIsPageLoading(true)
    try {
      let response = await GetDiagnosisData('')
      let diagnosis = JSON.parse(response.d)?.Data
      let data = await SaveExtra('Get_By_Type', 'generalPlanStatements', '', '')
      data = JSON.parse(data.d)?.Data || []
      // console.log("parse data", data)
      if (data) {
        data = data?.map((item) => {
          return {
            Id: item.Id,
            Data: JSON.parse(item?.JsonData),
          }
        })
      }
      if (data.length > 0) {
        let foundAccordionsForSelectedDiagnostic = await data.find((item) => item?.Data?.diagnosis?.label === selectedDiagnostic.name)
        if (foundAccordionsForSelectedDiagnostic) {
          setDataForSelectedDiagnostic((p) => ({
            ...p,
            'General Plan Statements': foundAccordionsForSelectedDiagnostic.Data?.accordions || [],
          }))
        }
      }
    } catch (error) {
      console.log(error)
    } finally {
      setIsPageLoading(false)
    }
  }

  const extractLinkedAssessments = (data) => {
    const processOptions = (options) =>
      options?.reduce((acc, option) => {
        if (option.linkedAssessment) {
          acc.push(...option.linkedAssessment)
        }
        if (option.linkedQuestion) {
          if (Array.isArray(option.linkedQuestion)) {
            option.linkedQuestion.forEach((nestedQuestion) => {
              acc.push(...processOptions(nestedQuestion.options))
            })
          } else if (typeof option.linkedQuestion === 'object') {
            acc.push(...processOptions(option.linkedQuestion.options))
          }
        }
        return acc
      }, []) || []
    return (
      data?.questionData?.reduce((acc, question) => {
        acc.push(...processOptions(question.options))
        return acc
      }, []) || []
    )
  }

  const fetchHPI = async () => {
    try {
      let formattedData
      if (selectedDiagnostic?.id) {
        formattedData = await SaveQuestionProvider('GET', '', 'HPI', selectedDiagnostic.id?.toString(), '')
        if (formattedData) {
          formattedData = JSON.parse(formattedData.d)?.Data || []
          formattedData = formattedData[0] || []
          if (formattedData.questionData) {
            formattedData = {
              ...formattedData,
              questionData: JSON.parse(formattedData.questionData).filter((item) => item !== null),
            }
          }
          if (formattedData) {
            const linkedAssessments = extractLinkedAssessments(formattedData)
            if (linkedAssessments.length > 0) {
              setDataForSelectedDiagnostic((p) => ({
                ...p,
                HPI: linkedAssessments || [],
              }))
            } else {
            }
            // setQuestionData(linkedAssessments)
          }
        }
      }
    } catch (error) {
      console.log(error)
    }
  }

  const fetchSubjective = async () => {
    try {
      let formattedData
      if (selectedDiagnostic?.id) {
        formattedData = await SaveQuestionProvider('GET', '', 'FollowUp', selectedDiagnostic.id?.toString(), '')
        if (formattedData) {
          formattedData = JSON.parse(formattedData.d)?.Data || []
          formattedData = formattedData[0] || []
          if (formattedData.questionData) {
            formattedData = {
              ...formattedData,
              questionData: JSON.parse(formattedData.questionData).filter((item) => item !== null),
            }
          }
          if (formattedData) {
            const linkedAssessments = extractLinkedAssessments(formattedData)
            if (linkedAssessments.length > 0) {
              setDataForSelectedDiagnostic((p) => ({
                ...p,
                Subjective: linkedAssessments || [],
              }))
            } else {
            }
            // setQuestionData(linkedAssessments)
          }
        }
      }
    } catch (error) {
      console.log(error)
    }
  }

  const fetchInjection = async () => {
    try {
      let formattedData
      if (selectedDiagnostic?.id) {
        formattedData = await SaveQuestionProvider('GET', '', 'incident', selectedDiagnostic.id?.toString(), '')
        if (formattedData) {
          formattedData = JSON.parse(formattedData.d)?.Data || []
          formattedData = formattedData[0] || []
          if (formattedData.questionData) {
            formattedData = {
              ...formattedData,
              questionData: JSON.parse(formattedData.questionData).filter((item) => item !== null),
            }
          }
          if (formattedData) {
            const linkedAssessments = extractLinkedAssessments(formattedData)
            if (linkedAssessments.length > 0) {
              setDataForSelectedDiagnostic((p) => ({
                ...p,
                Incident: linkedAssessments || [],
              }))
            } else {
            }
            // setQuestionData(linkedAssessments)
          }
        }
      }
    } catch (error) {
      console.log(error)
    }
  }

  useEffect(() => {
    if (selectedDiagnostic) {
      GetDiffrentialDiagnosis()
      GetGeneralPlanStatements()
      fetchHPI()
      fetchInjection()
      fetchSubjective()
      GetAssessmentSuggestion()
    }
  }, [selectedDiagnostic])

  const renderAccordions = (list, index) => {
    console.log(list)
    return (
      <div className=" ">
        <CRow>
          <div className="overflow-visible">
            {list?.map((item) => (
              <AccordianEditDelete
                title={item.title}
                accordion={item}
                // editAccordion={editAccordion}
                // deleteAccordion={deleteAccordion}
                content={
                  <div>
                    <div className="d-flex gap-2 justify-content-center" style={{ marginTop: '10px' }}>
                      {/* <CButton
                                            variant="outline"
                                            onClick={() => openModal(item.id)}
                                            color="info"
                                            className="custom-button shadow-sm"
                                            style={{
                                                padding: "5px 10px",
                                                borderRadius: "20px",
                                                fontSize: "12px",
                                                fontWeight: "500",

                                            }}
                                        >
                                            <i className="bi bi-plus-circle me-1"></i>Add/Edit Title
                                        </CButton> */}
                      {/* <CButton
                                            variant="outline"
                                            color="warning "
                                            onClick={() => {

                                                if (item.suggestions && !Array.isArray(item.suggestions) && item?.suggestions?.suggestionName.length > 0) {

                                                    item?.suggestions?.suggestionName?.map((s, index) => {
                                                        setSuggestionId(item.id)
                                                        setSuggestionModalVisible(true)
                                                        setSuggestionIndex(index)
                                                        setEditMode(true)
                                                        setSuggestionTitle(() => {

                                                            let data = item?.suggestions?.suggestionName
                                                            return data
                                                        })
                                                    })
                                                } else {

                                                    setSuggestionId(item.id);
                                                    setSuggestionModalVisible(true);
                                                }

                                            }}
                                            className={`custom-button shadow-sm  `}
                                            style={{
                                                padding: "5px 10px",
                                                borderRadius: "20px",
                                                fontSize: "12px",
                                                fontWeight: "500",
                                            }}
                                        >
                                            <i className="bi bi-lightbulb me-1"></i>Add/Edit Statements
                                        </CButton> */}
                    </div>

                    {item.suggestions && (
                      <ul className="list-group mt-4 mx-4">
                        <DifferentialSuggestion
                          suggestions={item?.suggestions?.suggestionName}
                          parentId={item.id}
                          orders={item?.suggestions?.orders}
                          // onSuggestionsChange={handleSuggestionsChange}
                          // setSaveResoanChange={setSaveResoanChange}
                          // submitDescription={submitDescription}
                          // setSubmitDescription={setSubmitDescription}
                        />
                      </ul>
                    )}

                    {item.children.length > 0 && <div className="mt-4">{renderAccordions(item.children)}</div>}
                  </div>
                }
              />
            ))}
          </div>
        </CRow>
      </div>
    )
  }

  return (
    <>
      <div className="position-relative patient-theme-page diagnosis-data-theme">
        <div className="patient-page-wrapper page-wrapper patient-theme-shell dashboard-dark-theme" style={{ minHeight: '100vh', overflow: 'auto' }}>
          <CRow className="p-2">
            {diagnosisData.map((item, index) => {
              let dataStatus = false
              return (
                <CCol xs={4} key={index}>
                  <ListView
                    showMatch={false}
                    heading={`${item.Name}[${item.Code}]`}
                    viewFunc={() => handleView(item)}
                    contentMatch={dataStatus.length > 0 ? true : false}
                  />
                </CCol>
              )
            })}
          </CRow>
        </div>
      </div>

      <CModal size="lg" onClose={() => setShowModal(false)} visible={showModal} className="patient-theme-modal diagnosis-data-theme__modal">
        <CModalHeader className="p-3" onClose={() => setShowModal(false)}>
          <CModalTitle>{selectedDiagnostic?.name || 'Diagnosis Details'}</CModalTitle>
        </CModalHeader>
        <CModalBody>
          <div className="d-flex flex-column gap-4">
            {Object.entries(dataForSelectedDiagnostic).map(([key, value]) => {
              return (
                <div key={key}>
                  <CAccordion flush>
                    <CAccordionItem itemKey={1}>
                      <CAccordionHeader>{key}</CAccordionHeader>
                      <CAccordionBody>{renderAccordions(value)}</CAccordionBody>
                    </CAccordionItem>
                  </CAccordion>
                </div>
              )
            })}
          </div>
        </CModalBody>
      </CModal>
    </>
  )
}

export default Diagnosisdata
